module.exports = __webpack_public_path__ + "staticcomp/img/cover.763a636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/6/cover.jpg
// module id = 67cH
// module chunks = 39